export default __webpack_public_path__ + "static/media/partnership-meteor-1.737c4a9f.png";